const numericCommaSeparation = (value) => {
    if (value) {
        return value.toString().replace(/\B(?=(?:(\d\d)+(\d)(?!\d))+(?!\d))/g, ',');
    }
    return "0"

}
export { numericCommaSeparation }